import { Component, computed, inject, resource, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core/auth/auth.service';
import { RettighedsType } from '@core/auth/rettighed.model';
import {
  DokumentAfsendelseResultComponent
} from '@features/dokumenter/afsendelse/dokument-afsendelse-result/dokument-afsendelse-result.component';
import {
  DokumentAfsendelseSearchComponent
} from '@features/dokumenter/afsendelse/dokument-afsendelse-search/dokument-afsendelse-search.component';
import { DokumentAfsendelseService } from '@features/dokumenter/afsendelse/dokument-afsendelse.service';
import { StmPropertyApi } from '@features/ssb-konfiguration/stm-property.api';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Panel } from 'primeng/panel';
import { ToggleSwitchChangeEvent, ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-dokumenter',
  imports: [
    DokumentAfsendelseResultComponent,
    DokumentAfsendelseSearchComponent,
    Panel,
    ToggleSwitchModule,
    FormsModule,
    ButtonModule,
    ConfirmDialog,
  ],
  providers: [ConfirmationService],
  templateUrl: './dokumenter-afsendelse.component.html',
  styleUrl: './dokumenter-afsendelse.component.css',
})
export class DokumenterAfsendelseComponent {
  confirmationService = inject(ConfirmationService);
  authService = inject(AuthService);
  dokAfsendelseService = inject(DokumentAfsendelseService);
  propertyApi = inject(StmPropertyApi);
  data = this.dokAfsendelseService.datasource.data;
  realtidEnabled = signal(false);

  realtid = resource({
    loader: async ({ abortSignal }) => {
      const response = await this.propertyApi.getList(
        {
          filter: JSON.stringify({
            noegle: 'ITC_DokumentAfsendelseAktiveret',
          }),
        },
        abortSignal
      );
      this.realtidEnabled.set(response.data[0].vaerdi === 'true');
      return response;
    },
  });

  visKonfiguration = computed(() =>
    this.authService.hasRettighed(RettighedsType.AdminSsbKonfiguration)
  );

  skrivKonfiguration = computed(() =>
    this.authService.hasRettighed(RettighedsType.AdminSsbKonfigurationSkriv)
  );

  async realtidChanged(e: ToggleSwitchChangeEvent) {
    const ssbRecord = this.realtid.value()?.data[0];
    if (ssbRecord && ssbRecord.id) {
      const newValue = e.checked;
      await this.propertyApi.update(ssbRecord.id, {
        ...ssbRecord,
        vaerdi: newValue ? 'true' : 'false',
      });
    }
  }

  resendInProgress = signal(false);
  async gensend() {
    this.confirmationService.confirm({
      message: 'Er du sikker?',
      header: 'Gensend dokumenter',
      rejectButtonProps: {
        label: 'Fortryd',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Gensend',
      },

      accept: async () => {
        this.resendInProgress.set(true);
        const ids = this.dokAfsendelseService
          .selectedDokumenter()
          .map((d) => d.id!);
        await this.dokAfsendelseService.datasource.gensend(ids);
        this.resendInProgress.set(false);
        await this.dokAfsendelseService.datasource.loadData();
      },
    });
  }
}
